export default __webpack_public_path__ + "static/media/ufo-2.01c2f4e9.webp";